import { Component } from '@angular/core'

@Component({
  selector: 'app-overdue-treatment-icon',
  templateUrl: './overdue-treatment-icon.component.html',
  styleUrls: ['./overdue-treatment-icon.component.scss'],
  standalone: true,
  imports: []
})
export class OverdueTreatmentIconComponent {
  constructor() {}
}
